import { createContext } from "react";

// Lets shared page components suppress transient UI while search is active
// without threading shell state through every route and dashboard section.
export const UniversalSearchOpenContext = createContext(false);